export const typeMap = {
  internal: 'internal-error',
  common: {
    invalidInputData: 'common/invalid-input-data',
    dataMismatch: 'common/data-mismatch',
    actionForbidden: 'common/action-forbidden',
    notFound: 'common/not-found',
    copyingToClipboardForbidden: 'common/copying-to-clipboard-forbidden',
  },
  conversion: {
    smilesToMol: 'molecule/conversion/smiles-to-mol',
    molfileToMol: 'molecule/conversion/molfile-to-mol',
    molToSmiles: 'molecule/conversion/mol-to-smiles',
    reactionToRxn: 'molecule/conversion/reaction-to-rxn',
  },
  parsing: {
    molfile: {
      general: 'parsing/molfile/general',
    },
  },
};
